import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ServiceService } from '../../../service.service';

interface Department {
  _id?: string;
  department_id: string;
  department_code?: string;
  department_name?: string;
  department_Foreman_name?: string;
  is_factory?: boolean;
  warehouse_name?: string;
}

@Component({
  selector: 'app-department-list',
  templateUrl: './department-list.component.html',
  styleUrls: ['./department-list.component.css'],
})
export class DepartmentListComponent implements OnInit {
  departments: Department[] = [];
  filteredDepartments: Department[] = []; // kept for table bindings

  isLoading = false;
  loadError: string | null = null;

  constructor(
    private apiService: ServiceService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.loadDepartments();
  }

  // Call viewDepartments API
  loadDepartments(): void {
    this.isLoading = true;
    this.loadError = null;

    // Make sure this exists in your service:
    // ViewDepartments() { return this.http.get<any>(this.baseUrl + 'viewDepartments'); }
    this.apiService.ViewDepartments().subscribe({
      next: (res: any) => {
        this.isLoading = false;
        if (res && res.success && Array.isArray(res.data)) {
          this.departments = res.data;
          // No search, so filtered list is just full list
          this.filteredDepartments = [...this.departments];
        } else {
          this.departments = [];
          this.filteredDepartments = [];
          this.loadError = 'Unable to load departments.';
        }
      },
      error: (err: any) => {
        console.error('Error loading departments:', err);
        this.isLoading = false;
        this.departments = [];
        this.filteredDepartments = [];
        this.loadError = 'Failed to load departments from server.';
      },
    });
  }

  // Navigate to shift assignment for selected department
  goToShiftAssignment(dept: Department): void {
    if (!dept || !dept.department_id) return;

    // Store department_id so ShiftAssignmentComponent can pick it up
    localStorage.setItem('department_id', dept.department_id);
    localStorage.setItem('department_name', dept.department_name || 'Department');

    this.router.navigate(['/admin/shift-assignment']);
  }
}
